import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import DomainOutlined from '@mui/icons-material/DomainOutlined';
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined';

import { LandingCard, LandingReveal, landingCaptionSx } from './LandingMotion';

const audiences = [
  {
    title: 'Organizations',
    mark: DomainOutlined,
    body:
      'Companies, academies, and business units that reuse the same knowledge across situations.',
  },
  {
    title: 'Expert partners',
    mark: HandshakeOutlined,
    body:
      'Consultancies and educators who turn their methods into practice for client programs.',
  },
];

const ForOrganizations = () => (
  <Box
    id="for-organizations"
    component="section"
    sx={{
      bgcolor: 'background.paper',
      py: { xs: 8, md: 12 },
      borderTop: '1px solid',
      borderColor: 'divider',
      scrollMarginTop: 88,
    }}
  >
    <Container maxWidth="lg">
      <LandingReveal>
        <Typography variant="caption" sx={landingCaptionSx}>
          For organizations and educators
        </Typography>
        <Typography
          component="h2"
          sx={{
            mt: 1,
            mb: 1.5,
            fontWeight: 600,
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            letterSpacing: '-0.02em',
            maxWidth: 560,
          }}
        >
          Reuse knowledge across situations
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 5, maxWidth: 560 }}>
          For companies, academies, and consulting or education partners.
        </Typography>
      </LandingReveal>

      <Grid container spacing={2.5}>
        {audiences.map((item, index) => (
          <Grid item xs={12} sm={6} key={item.title} sx={{ display: 'flex' }}>
            <LandingReveal index={index} sx={{ width: '100%', height: '100%' }}>
              <LandingCard kind="audience" mark={item.mark} tone="quiet" title={item.title} body={item.body} />
            </LandingReveal>
          </Grid>
        ))}
      </Grid>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 3, maxWidth: 560 }}>
        Itclarifies complements expertise and facilitators. It is not a
        conventional course library, a document-to-quiz tool, or a universal
        business simulator.
      </Typography>
    </Container>
  </Box>
);

export default ForOrganizations;
